import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  div {
    width: 100%;
  }
`;

export const Container = styled.section`
  background-color: ${ColorPalette.HEX.Lotion};
  @media ${({ theme }) => theme.device.desktop} {
    background: none;
    max-width: 1300px;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};
`;

export const HeaderTitle = styled.label`
  font-weight: 600;
  line-height: 80px;
  letter-spacing: -0.2px;
  text-align: center;
  padding: 0px;
  color: ${({ theme }) => theme.simpleHeader.titleColor};
`;

export const HeaderEdit = styled.button`
  font-weight: 600;
  text-align: right;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  font-size: 19px;
  cursor: pointer;
  background: ${ColorPalette.Transparent};

  @media ${({ theme }) => theme.device.mobile} {
    position: absolute;
    right: 24px;
    top: 28px;
    font-size: 14px;
  }
`;

export const PreferencesTitle = styled.h4`
  font-size: 24px;
  font-weight: 600;
  margin: 25px 0 32px 16px;
  line-height: 1.33;
  letter-spacing: -0.4px;
  color: ${ColorPalette.HEX.PineTree};
`;
